import { render, staticRenderFns } from "./MypageDepositModal.vue?vue&type=template&id=5ab00ddd&scoped=true"
import script from "./MypageDepositModal.vue?vue&type=script&lang=js"
export * from "./MypageDepositModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab00ddd",
  null
  
)

export default component.exports